import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import emailjs from 'emailjs-com';
import './ShortTermCourses.css';

// Import images
import topImage from '../../assets/images/shcrs.jpg';
import cor1 from '../../assets/images/short-term-courses-images/Picture1c.png';
import cor2 from '../../assets/images/short-term-courses-images/Picturec++.png';
import cor3 from '../../assets/images/short-term-courses-images/java.png';
import cor4 from '../../assets/images/short-term-courses-images/Picturepython.png';
import cor5 from '../../assets/images/short-term-courses-images/Picturesql.png';
import cor6 from '../../assets/images/short-term-courses-images/Picturelinux.png';
import cor7 from '../../assets/images/short-term-courses-images/Picturemic.png';
import cor8 from '../../assets/images/short-term-courses-images/Picturehtml.png';

const ShortTermCourses = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [selectedCourse, setSelectedCourse] = useState('');

    const handleApplyClick = (courseName) => {
        setSelectedCourse(courseName);
        setIsModalVisible(true);
    };

    const handleFormSubmit = (values) => {
        const emailParams = {
            name: values.name,
            email: values.email,
            phone: values.phone,
            selectedCourse: selectedCourse,
        };

        emailjs
            .send(
                'service_oit4bk9', // Your service ID
        'template_xny0vd6', // Your template ID
        emailParams,
        '6xlgr_2EFvcPEjnDG' // Your user ID
            )
            .then(
                () => {
                    message.success(`Application submitted for ${selectedCourse}`);
                    setIsModalVisible(false);
                    form.resetFields();
                },
                (error) => {
                    console.error('EmailJS Error:', error);
                    message.error('Failed to submit application. Please try again.');
                }
            );
    };

    return (
        <div style={{ paddingTop: '0px' }}>
            <div className="top-image-container">
                <img src={topImage} alt="Short Term Courses" className="top-image" />
            </div>
            <h1 style={{ textAlign: 'center' }}>Short Term Courses</h1>

            {/* Course 1: C Programming */}
            <div className="course-cards" id='c'>
                <div className="image-section">
                    <img src={cor1} alt="C Programming" />
                </div>
                <div className="content-section">
                    <h2>C Programming</h2>
                    <p><strong>Course Details:</strong><br />The promise of this course is to help train and strengthen on “C programming skills”. The C
                        training course covers C Programming language essentials such as programming techniques,
                        decision-making statements, iterations, functions, 1D arrays, 2D arrays, pointers, dynamic
                        memory allocation for arrays as well as structures.</p>
                    <p>To master any programming language, one needs hands-on practice along with clarity of
                        concepts. The course emphasizes on Best Practice, Interview Tip, Group Exercise, and
                        Classroom Quiz to help increase your curiosity and also help you to become an expert with
                        knowledge of peripheral concepts.
                    </p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Operating computer</li>
                        <li>Knowledge of programming techniques would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Develop simple console-based programs using C language with features like
                            decision-making statements, loops, functions & arrays.
                        </li>
                        <li>Develop C programs using structures, pointers & dynamic memory allocation.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('C Programming')}>
                        To Register
                    </button>
                </div>
            </div>

            {/* Course 2: C++ Programming */}
            <div className="course-cards" id='C++'>
                <div className="image-section">
                    <img src={cor2} alt="C++ Programming" />
                </div>
                <div className="content-section">
                    <h2>C++ Programming</h2>
                    <p><strong>Course Details:</strong><br />The promise of this course is to help train and strengthen in “C++ programming skills”. The
                        C++ training course covers C++ Programming language essentials such as programming
                        techniques, Object Oriented Programming Concepts (inheritance, polymorphism,
                        Encapsulation, Abstraction), Dynamic binding, Standard Template Library, Multi-threading,
                        Signal Handling and Exception handling.
                    </p>            <strong>Prerequisite:</strong>
                    <ul>
                        <li>Operating computer</li>
                        <li>Knowledge of C++ programming would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Develop simple console-based programs using C++ language with system level
                            features
                        </li>
                        <li>Develop C++ programs for high performance applications as Operating System, IOT
                            and cloud computing</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('C++ Programming')}>
                        To Register
                    </button>
                </div>
            </div>

            {/* Course 3: Java Programming */}
            <div className="course-cards" id='java'>
                <div className="image-section">
                    <img src={cor3} alt="Java Programming" />
                </div>
                <div className="content-section">
                    <h2>Java Programming</h2>
                    <p><strong>Course Name:</strong><br />The Java programming language is a general-purpose programming language that is based
                        on the OOPs concept. Java is a platform-independent and robust programming language.
                        The Java Programming Training provides an exhaustive coverage of features like Objectoriented Programming, Inheritance, Interfaces, Exception Handling, Reflection, Standard
                        I/O programming, File Handling, Generics, GUI programming with Swing, Applets,
                        MultiThreading, Socket Programming, JDBC, Struts Framework, Web Application Component
                        development with Servlets, JSP and XML., Spring and Spring Boot</p>
                    <p>To master any programming language, one needs hands-on practice along with clarity of
                        concepts. The course emphasizes on Best Practice, Interview Tip, Group Exercise, and
                        Classroom Quiz to help increase your curiosity and also help you to become an expert with
                        knowledge of peripheral concepts.</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>C Programming</li>
                        <li>Knowledge of Object-oriented programming would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Apply OOAD concepts to build Best Java applications.( New JDK features like
                            Lambda expressions, Functional Interfaces etc.</li>
                        <li>Develop web based applications using Java to enroll best java course provider in
                            pune with 100% Placement assistance.
                        </li>
                        <li>Create Unit Test cases using Junit</li>
                        <li>Able to create Microservices using Spring Boot and Rest</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Java Programming')}>
                        To Register
                    </button>
                </div>
            </div>

            {/* Course 4: Python Programming */}
            <div className="course-cards" id='python'>
                <div className="image-section">
                    <img src={cor4} alt="Python Programming" />
                </div>
                <div className="content-section">
                    <h2>Python Programming</h2>
                    <p><strong>Course Details:</strong><br />Python is an easy programming language for beginners to start out with. It’s newer than a
                        lot of languages, so it’s easier to learn than some of the other languages and there’s a lot
                        of demand for Python programmers, this course provides exhaustive coverage of Python
                        Programming language.
                    </p>
                    <p>To master any programming language, one needs hands-on practice along with clarity of
                        concepts. The course covers Python Programming language essentials such as programming
                        techniques with functions, modules, Data structures lists, tuples, sets, and dictionaries
                        Object Oriented Programming with Objects and classes and File Handling and tkinter library</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Operating computer</li>
                        <li>Knowledge of programming techniques would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Apply OOAD concepts to build python applications.</li>
                        <li>Develop console-based programs using python.</li>
                        <li>Develop GUI applications using Python.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Python Programming')}>
                        To Register
                    </button>
                </div>
            </div>

            {/* Course 5: SQL Fundamentals */}
            <div className="course-cards" id='sql'>
                <div className="image-section">
                    <img src={cor5} alt="SQL Fundamentals" />
                </div>
                <div className="content-section">
                    <h2>SQL Fundamentals</h2>
                    <p><strong>Course Details :-</strong><br />SQL is a standard language for storing, manipulating and retrieving data in databases. SQL
                        is used to communicate with a database. It is the standard language for relational database
                        management systems. SQL statements are used to perform tasks such as update data on a
                        database, or retrieve data from a database.</p>
                    <p>To master any programming language one needs hands-on practice along with clarity of
                        concepts. The course emphasizes on Best Practice, Interview Tip, Group Exercise, and
                        Classroom Quiz to help increase your curiosity and also help you to become an expert with
                        knowledge of peripheral concepts.
                    </p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Computer Fundamentals</li>
                        <li>Windows Operating System</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Create tables.</li>
                        <li>Use different SQL statements to retrieve and manipulate data</li>
                        <li>Use different types of Built in Functions.</li>
                        <li>Handle data from multiple tables.</li>
                        <li>Manipulate data from multiple tables using the INSERT, UPDATE and DELETE
                            command.</li>
                        <li>Create and use other database objects like index, sequence, views and synonyms.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('SQL Fundamentals')}>
                        To Register
                    </button>
                </div>
            </div>
            <div className="course-cards" id='linux'>
                <div className="image-section">
                    <img src={cor6} alt="Linux" />
                </div>
                <div className="content-section">
                    <h2>Linux</h2>
                    <p><strong>Course Details:</strong><br />Linux is an operating system based on UNIX and is becoming increasingly popular. Linux is
                        also distributed under an open-source license. To build on an in-demand career in cloud,
                        devops, web, networking and sysadmin it is very crucial to have the linux skills. This training
                        covers the Linux basics, Virtualization, Bash script programming, File Systems and
                        Networking topics that includes DHCP, NAT, DNS, SAMBA, NFS, Email and Web Server. The
                        Linux used could be Ubuntu, RedHat, Fedora and Suse.</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Operating computer</li>
                        <li>Knowledge of programming techniques would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Able to install and setup a Linux server</li>
                        <li>Deploy any user application for the use of local systems</li>
                        <li>Configure and maintain Linux servers as sysadmin taking auto backups,
                            troubleshooting networking issues</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Linux')}>
                        To Register
                    </button>
                </div>
            </div>

            <div className="course-cards" id='basic'>
                <div className="image-section">
                    <img src={cor7} alt="Basic Office Skills" />
                </div>
                <div className="content-section">
                    <h2>Basic Office Skills</h2>
                    <p><strong>Course Details:</strong><br />MS Office is the most widely-used software suite for businesses worldwide. Irrespective of
                        size or sector, MS Office forms the backbone of most organisations’ everyday administrative
                        operations. A good grasp of the basics of MS Office will enable you to pass employers’ initial
                        qualification checks when applying for jobs. Business owners, entrepreneurs and senior
                        managers could also benefit significantly from familiarity with the most important features
                        and functions of Microsoft Office.</p>
                    <p><strong>Course Details:</strong>This training covers the Getting started with word, excel, PowerPoint, identifying the
                        elements of the interface, working with data and analysis with excel, creating decent
                        presentation with Picture formatting, SmartArt Graphics and tables using PowerPoint.</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>A PC with Microsoft Office Suit installed </li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>To use Microsoft Word, Excel, PowerPoint to create, format, and edit documents.</li>
                        <li> Effectively use formulas, functions, charts, and graphs in Excel.</li>
                        <li>Master of VLOOKUP, XLOOKUP, and Pivot table to create speedy Data Analytics.</li>
                        <li>To use Microsoft PowerPoint to create dynamic and engaging presentations.</li>
                        <li>How to create a mail merge in Microsoft Word.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Basic Office Skills')}>
                        To Register
                    </button>
                </div>
            </div>

            <div className="course-cards" id='hcj'>
                <div className="image-section">
                    <img src={cor8} alt="HTML / CSS / JS" />
                </div>
                <div className="content-section">
                    <h2>HTML / CSS / JS</h2>
                    <p><strong>Course Details:</strong><br />Web development refers to creating, building, and maintaining of websites. It includes
                        aspects such as web design, web publishing, web programming, and database management.
                        The triune subjects in web development- HTML, CSS, and JavaScript forms the key
                        technologies to form the backbone of modern web design and development, enabling the
                        creation of engaging, accessible, and responsive websites. It is the creation of an application
                        that works over the internet i.e. websites</p>
                    <p>This is also called as Front-end Development which is the development or creation of a
                        user interface using some markup languages and other tools. It is basically the development
                        of the user side where only user interaction will be counted. It consists of the interface
                        where buttons, texts, alignments, etc are involved and used by the user.</p>
                    <p>This introductory course will delve into the essentials of HTML, CSS, and JavaScript to
                        provide a solid foundation for aspiring web developers. </p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Operating computer</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Able to develop static web sites</li>
                        <li>Learn to update and maintain HTML sites easily</li>
                        <li>Techniques to make web pages functional across different devices.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('HTML / CSS / JS')}>
                        To Register
                    </button>
                </div>
            </div>
            {/* Add similar sections for Linux, Office Tools, and HTML/CSS/JS */}

            {/* Application Modal */}
            <Modal
                title={`Apply for ${selectedCourse}`}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Please enter your name!' }]}
                    >
                        <Input placeholder="Your Name" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Please enter your email!' },
                            { type: 'email', message: 'Please enter a valid email!' },
                        ]}
                    >
                        <Input placeholder="Your Email" />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Phone Number"
                        rules={[{ required: true, message: 'Please enter your phone number!' }]}
                    >
                        <Input placeholder="Your Phone Number" />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Submit Application
                    </Button>
                </Form>
            </Modal>
        </div>
    );
};

export default ShortTermCourses;
